<template>
        <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Neues Oasis-Zertifikat anlegen</h3>
                        <h6 class="text-uppercase text-muted ls-1 mb-0">Bevor die einzelnen Standorte eingerichtet werden können, muss zunächst Ihr Oasis-Zertifikat angelegt werden.</h6>
                    </div>
                </div>
            </div>
            <template>
                <form @submit.prevent="create">
                    <!--- <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert> --->
                    <certform ref="UForm"/>
                    <div class="pl-lg-4">
                    <div class="row">
                        <div class="col">
                            <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading || !isCompleted">
                                <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                                <span class="btn-inner--text">Zertifikat anlegen</span></button>
                        </div>
                    </div>
                    </div>
                </form>
            </template>
        </card>
</template>

<script>
    import Certform from "@/views/OasisCerts/Certform";

    export default {
        name: "create",
        components: {Certform},
        data() {
            return {
                isLoading: false,
                mountedDOM: false,
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        mounted() {
            this.mountedDOM = true
        },
        computed: {
            isCompleted() {
                return (this.mountedDOM) ? (this.$refs.UForm.rootCert !== '' && this.$refs.UForm.privateCert !== '') : false
            }
        },
        methods: {
            create() {
                this.$store.dispatch('alert/clear');
                this.$refs.UForm.submitFiles().then(() =>{
                    if (this.$refs.UForm.cert.rootCert === '' || this.$refs.UForm.cert.privateCert === '') {
                        this.$store.dispatch('alert/error','Bitte Zertifikate hochladen');
                    } else {
                        this.isLoading = true;
                        this.createCert()
                            .then(response => {
                                this.isLoading = false;
                                this.status =  {type: 'success', msg: 'Zertifikat (ID: '+response.id+') wurde erstellt. '};
                                this.$store.dispatch('alert/success',this.status.msg);

                                this.$router.push('/oasiscerts');
                            })
                            .catch(error => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/error',error);
                                //this.status =  {type: 'danger', msg: error};
                            })
                    }
                });
            },
            createCert() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = this.$refs.UForm.cert;
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/oasis_certs`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                            },
                            error => {
                                reject(error);
                            });
                });
            }
        }
    }
</script>

